import { Component, OnInit } from '@angular/core';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { ConfirmationModalComponent } from 'libs/portal/src/modules/home/components/user/components/confirmation-modal/confirmation-modal.component';
import { Endpoints } from '@huge-monorepo/portal/config';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';
import { SharedGenericSingletonService } from '@huge-monorepo/shared/services';
import { ICustomerGenericService, IHIPGenericService } from '@huge-monorepo/shared/interfaces';

@Component({
  selector: 'app-account-management-menu',
  templateUrl: './account-management-menu.component.html',
  styleUrls: ['./account-management-menu.component.scss'],
})
export class AccountManagementMenuComponent implements OnInit {
  isLightMode = this.sharedGenericService.getIsLightMode();
  path = this.sharedGenericService.getPath(!this.isLightMode);
  ScreenSize = ScreenSize;
  groupAdmin = false;
  obfuscate = false;
  preferedGraphValue: string;
  modalStyle: string = this.layoutService.screenSize > this.ScreenSize.MOBILE_L ? 'auto-height' : '';
  activeIndex: number;

  constructor(
    private nav: NavigationService,
    private auth: UserRightsService,
    private layoutService: LayoutService,
    private sharedGenericService: SharedGenericSingletonService< ICustomerGenericService | IHIPGenericService >,
    private endpoints: Endpoints,
    private genericService: GenericService,
    private toastService: ToastrService,
    private dialogRef: MatDialogRef<AccountManagementMenuComponent>,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {

  }

  navigateTo(url: string | null, queryParams?: any) {
    if (!url) {
      return;
    }
    this.nav.SetActiveIndex(this.activeIndex);
    // this.nav.SetIsCollapsed(this.isCollapsed);
    this.nav.Navigate(url, queryParams);
    this.dismissOverlay()
  }

  logout() {
    this.openConfirmationModal();
  }

  async dismissOverlay() {
    this.dialogRef.close();
  }

  async openConfirmationModal() {
    const dialogRefI = this.dialog.open(ConfirmationModalComponent, {
      data: {
        confimationMessage: 'Are you sure that you would like to logout?',
      },
      panelClass: this.modalStyle,
    });

    let dialogSub = dialogRefI.afterClosed().subscribe({
      next: (dataReturned) => {
        if (dataReturned) {
          this.genericService.GET(this.endpoints.LOGOUT).subscribe(
            (res) => {
              this.auth.Logout();
              this.toastService.success('', (res as any).body, { timeOut: 2000 });
            },
            () => {
              this.auth.Logout();
            },
          );
        }
        this.dismissOverlay();
        dialogSub.unsubscribe();
      },
    });
  }
}
